import {
	AuthenticationApi,
	AvviaPraticaRequest,
	Configuration,
	PraticaApi,
	PraticaDto,
	ResumePraticaDto,
	ResumePraticaRequest,
	SendResumeLinkRequest,
	SuspendPraticaRequest,
	SuspendPraticaStepStatusEnum,
} from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";

enum PraticaReducer {
	avviaPratica = "[PRATICA] Avvia",
	riprendi = "[PRATICA] Riprendi",
	setId = "[PRATICA] Set ID",
	riprendiInSeguito = "[PRATICA] Riprendi in Seguito",
	recupera = "[PRATICA] Recupera",
}

export const praticaSetId = createAction<string>(PraticaReducer.setId);

export const praticaAvviaPratica = createAsyncThunk<
	PraticaDto | undefined,
	AvviaPraticaRequest,
	ThunkApiConfig
>(PraticaReducer.avviaPratica, async (request, { dispatch, extra, getState }) => {
	try {
		return await new PraticaApi(getConfiguration(Configuration, extra, getState)).avviaPratica(
			request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const praticaRecupera = createAsyncThunk<string | undefined, string, ThunkApiConfig>(
	PraticaReducer.recupera,
	async (email, { dispatch, extra, getState }) => {
		try {
			let request: SendResumeLinkRequest = {
				email,
			};

			return await new AuthenticationApi(
				getConfiguration(Configuration, extra, getState)
			).sendResumeLink(request);
		} catch (e) {
			errorHandler(e, dispatch);
		}
	}
);

export const praticaRiprendiInSeguito = createAsyncThunk<
	PraticaDto | undefined,
	SuspendPraticaStepStatusEnum,
	ThunkApiConfig
>(PraticaReducer.riprendiInSeguito, async (stepStatus, { dispatch, extra, getState }) => {
	try {
		let idPratica = getState()?.pratica?.idPratica;
		// let stepStatus = SuspendPraticaStepStatusEnum.RicercaRappLegale;

		if (!idPratica) throw "Id Pratica assente";

		let request: SuspendPraticaRequest = {
			idPratica,
			stepStatus,
		};

		return await new PraticaApi(getConfiguration(Configuration, extra, getState)).suspendPratica(
			request
		);
	} catch (e) {
		errorHandler(e, dispatch);
	}
});

export const praticaRiprendi = createAsyncThunk<
	ResumePraticaDto | undefined,
	ResumePraticaRequest,
	ThunkApiConfig
>(PraticaReducer.riprendi, async (request, { dispatch, extra, getState }) => {
	try {
		return await new AuthenticationApi(getConfiguration(Configuration, extra, getState))
			.resumePratica(request)
			.then((res) => {
				return res;
			});
	} catch (e) {
		errorHandler(e, dispatch);
	}
});
